// extracted by mini-css-extract-plugin
export default {"input":"EditAcademyProjectInput_input__P6pup","removeButton":"EditAcademyProjectInput_removeButton__vsk+4"};